import React, {useEffect, useRef, useState} from 'react';


import Box from "@mui/material/Box";
import { InputLabel, Select, Stack, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {useForm} from "react-hook-form";


import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {
    getSources
} from "./SubscriberClient";
import {changeSubscriber} from "./subscriberSlice";
import {changeSubscriberSearch} from "./subscriberSearchSlice";
import {getPlatformNames, getServices} from "../Platform/PlatformClient";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import CircularProgressOverlay from "../../CommonComponents/CircularProgressOverlay";




export default function SubscriberSearch({gridClear}) {

    const selectorSubmitting = useSelector((state) => state.externalDataSlc.value.submitting);

    const { register, handleSubmit, control, setValue, reset } = useForm();
    // const {register, handleSubmit} = useForm();
    const [platformNameDropdown, setPlatformNameDropdown] = useState([]);
    const [selectedPlatformName, setSelectedPlatformName] = useState('');
    const [initialMarketDropdown, setInitialMarketDropdown] = useState([]);
    const [selectedInitialMarket, setSelectedInitialMarket] = useState('');
    const [serviceDropdown, setServiceDropdown] = useState([]);
    const [selectedService, setSelectedService] = useState('');
    const [sourceDropdown, setSourceDropdown] = useState([]);
    const [selectedSource, setSelectedSource] = useState('');
    const [subscriberValue, setSubscriberValue] = useState([]);
    const [guildValue, setGuildValue] = useState([]);
    const [r2mValue, setR2mValue] = useState([]);
    const dispatchData = useDispatch();
    const [subscribers, setSubscribers] = useState([]);

    const handleClearClick = () => {
        setSubscriberValue("");
    };



    const fetchPlatformNames = () =>
        getPlatformNames()

            .then(data => {
                console.log("M4Mkt Groups");
                console.log(data);
                console.log("M4Mkt Groups with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setPlatformNameDropdown(data);
            })

    const fetchServices = () =>
        getServices()

            .then(data => {
                console.log("Services");
                console.log(data);
                console.log("Services with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setServiceDropdown(data);
            })

    const fetchSources = () =>
        getSources()

            .then(data => {
                console.log("Production Types");
                console.log(data);
                console.log("Production Types with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setSourceDropdown(data);
            })

    useEffect(() => {
        console.log("This is for the M4mkt Group dropdown...");
        fetchPlatformNames();
        fetchServices();
        fetchSources();
    }, []);


    function onSubmit(data) {
        console.log("here's my subscriber search data before I submit it ")
        console.log({data});
        dispatchData(changeSubscriberSearch({
            // searchData: data
            id: data.id,
            externalId: data.externalId,
            platformId: data.platformId,
            platformName: data.platformName,
            service: data.service,
            countDateFrom: data.countDateFrom,
            countDateTo: data.countDateTo,
            subCountFrom: data.subCountFrom,
            subCountTo: data.subCountTo,
            source: data.source
        }));
        dispatchData(changeSubscriber({
            subscriberGridRefresh: true
        }));
    };


    const handleClear = () => {

        reset({
            id: '',
            externalId: '',
            platformId: '',
            platformName: '',
            service: '',
            countDateFrom: '',
            countDateTo: '',
            subCountFrom: '',
            subCountTo: '',
            source: ''
        });

            setSelectedPlatformName('');
            setSelectedService('');
            setSelectedSource('');

        gridClear()

    };

    const handlePlatformNameChange = (platformNameEvent) => {
        setSelectedPlatformName(platformNameEvent.target.value);
        console.log("This is for the selected Value");
        console.log(platformNameEvent.target.value);
    };

    const handleServiceChange = (serviceEvent) => {
        setSelectedService(serviceEvent.target.value);
        console.log("This is for the selected Value");
        console.log(serviceEvent.target.value);
    };

    const handleSourceChange = (sourceEvent) => {
        setSelectedSource(sourceEvent.target.value);
        console.log("This is for the selected Value");
        console.log(sourceEvent.target.value);
    };


    const selectR2mRef = useRef();

    const onClear = () => {
    };

    const searchForm  = () => (
        <form
            onSubmit={handleSubmit((data)=>        onSubmit(data))}
        >
            <Box
                sx={{  height: 220, pl: 5}}
                role="presentation"
            >
                <Stack direction={"Horizontal"} sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('id', { required: false })}
                               id="id"   name="id"  label="ID" aria-describedby="id_entry"
                               sx={{ width: 100, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('externalId', { required: false })}
                               id="externalId"   name="externalId"  label="External ID" aria-describedby="externalId_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('platformId', { required: false })}
                               id="platformId"   name="platformId"  label="Platform ID" aria-describedby="platformId_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <FormControl variant="standard" sx={{ ml: 1, pr: 5, minWidth: 300 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="platformName">Platform Name</InputLabel>
                        <Select
                            {...register('platformName', { required: false })}
                            labelId="demo-simple-select-filled-platformName"
                            id="platformName"
                            FreeSolo={true}
                            variant="filled"
                            label="platformName"
                            value={selectedPlatformName}
                            onChange={handlePlatformNameChange}
                            sx={{ width: 300}}
                        >
                            {platformNameDropdown.map((platformNameItem) =>
                                <MenuItem  FreeSolo={true} value={platformNameItem.singleField} key={platformNameItem.singleField}
                                >{platformNameItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="service">Service</InputLabel>
                        <Select
                            {...register('service', { required: false })}
                            labelId="demo-simple-select-filled-service"
                            id="service"
                            FreeSolo={true}
                            variant="filled"
                            label="service"
                            value={selectedService}
                            onChange={handleServiceChange}
                            sx={{ width: 200}}
                        >
                            {serviceDropdown.map((serviceItem) =>
                                <MenuItem  FreeSolo={true} value={serviceItem.singleField} key={serviceItem.singleField}
                                >{serviceItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="source">Source</InputLabel>
                        <Select
                            {...register('source', { required: false })}
                            labelId="demo-simple-select-filled-source"
                            id="source"
                            FreeSolo={true}
                            variant="filled"
                            label="source"
                            value={selectedSource}
                            onChange={handleSourceChange}
                            sx={{ width: 200}}
                        >
                            {sourceDropdown.map((sourceItem) =>
                                <MenuItem  FreeSolo={true} value={sourceItem.singleField} key={sourceItem.singleField}
                                >{sourceItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Stack>
                <Stack direction={"horizontal"}  sx={{ pb: 1 }}>
                    <FormDatePicker
                        name="countDateFrom"
                        label="Count Date From"
                        control={control}
                        width={210}
                    />
                    <FormDatePicker
                        name="countDateTo"
                        label="Count Date To"
                        control={control}
                        width={210}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('countDateFrom', { required: false })}*/}
                    {/*           id="countDateFrom"   name="countDateFrom"  label="Count Date From" aria-describedby="countDateFrom_entry"*/}
                    {/*           sx={{ width:200, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('countDateTo', { required: false })}*/}
                    {/*           id="countDateTo"   name="countDateTo"  label="Count Date To" aria-describedby="countDateTo_entry"*/}
                    {/*           sx={{ width:200, pr: 5 }} />*/}
                    <TextField variant="filled"
                               {...register('subCountFrom', { required: false })}
                               id="subCountFrom"   name="subCountFrom"  label="Subscriber  Count From" aria-describedby="subCountFrom_entry"
                               sx={{ width: 260, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('subCountTo', { required: false })}
                               id="subCountTo"   name="subCountTo"  label="Subscriber  Count  To" aria-describedby="subCountTo_entry"
                               sx={{ width: 260, pr: 5 }} />
                    <Button
                        type= "submit"
                    >RETRIEVE</Button>
                    <Button onClick={handleClear}
                    >CLEAR</Button>
                </Stack>
            </Box>
        </form>
    );

    return (
        <Box sx={{ position: 'relative' }}>
            {searchForm()}
            {selectorSubmitting && <CircularProgressOverlay/>}
        </Box>

    )


}

